module.exports = __webpack_public_path__ + "static/media/locationIcon.330c1167.png";